import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import UnlimitedCallPackForm from '../forms/UnlimitedCallPackForm'
import globals from '../globals'

class UnlimitedCallPackModule extends React.Component {
    render () {
        return (
            <div className='unlimited-call-pack-module module'>
                <div id='sub-navigation' />{/* This is for scrollToNav method in FormHOC */}
                <Heading title='Upgrade to Unlimited Home Phone' />
                <ModuleWithLoader isLoaded={this.props.isLoaded} hasError={this.props.hasError}>
                    <div className='row p-4'>
                        {this.props.voipServices.length > 0
                            ? <React.Fragment>
                                <div className='col-12 col-md-8 offset-md-2 text-center'>
                                    <p>You can upgrade your Exetel phone service here to Unlimited Home Phone and enjoy unlimited national calls and unlimited international calls to landlines in the countries listed below.</p>
                                </div>
                                <div className='col-12 col-md-8 offset-md-2'>
                                    <UnlimitedCallPackForm
                                        numbers={this.props.voipServices}
                                        plans={this.props.plans}
                                        handleSuccess={() => globals.pushEvent('OrderNewVoipCallpack')}
                                    />
                                </div>
                              </React.Fragment>
                            : <div className='col-12 col-md-8 offset-md-2 text-center'>
                                <p>Your account does not not currently have any active VoIP services.</p>
                            </div>}

                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

UnlimitedCallPackModule.propTypes = {
    isLoaded: PropTypes.bool.isRequired,
    hasError: PropTypes.bool.isRequired,
    voipServices: PropTypes.array.isRequired,
    plans: PropTypes.array.isRequired
}

export default UnlimitedCallPackModule



// WEBPACK FOOTER //
// ./resources/js/modules/UnlimitedCallPackModule.js